import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { ReactComponent as InfoIcon } from 'assets/img/icons/warning_darker.svg';

export default function InfoBanner({
  icon = null,
  children = null,
  gap = '20',
  iconSize = '40',
  isInvalid = false,
  className = '',
  iconClassName = '',
  messageClassName = ''
}) {
  if (!children) return null;

  return (
    <UiKit.Grid
      gap={gap}
      templateColumns={`${iconSize}px 1fr`}
      className={cn(
        styles.container,
        { [styles.invalid]: isInvalid },
        className
      )}
    >
      {icon || (
        <InfoIcon
          width={iconSize}
          height={iconSize}
          className={cn(styles.icon, iconClassName)}
        />
      )}
      <div className={cn(styles.msg, messageClassName)}>{children}</div>
    </UiKit.Grid>
  );
}
